<template>
    <section
        id="pif-infos"
        class="border border-light py-1 px-1 mb-2 alert-fix"
    >
        <h4 class="h4 h4-fix mb-0">
            {{ pifInfos.title }}
        </h4>
        <div v-if="pifInfos.radInfos" class="alert-container alert-info">
            <p class="alert" role="alert">
                <span class="alert-icon" aria-hidden="true" />
                <span class="ob1-alert-title">
                    {{ pifInfos.radInfos.content }}
                </span>
            </p>
            <div class="alert-content">
                <a
                    :href="pifInfos.url"
                    class="ob1-link-arrow ob1-link-dark ob1-link-large"
                    :data-oevent-category="pifInfos.radInfos.buttonTms.category"
                    :data-oevent-action="pifInfos.radInfos.buttonTms.action"
                    :data-oevent-label="pifInfos.radInfos.buttonTms.label"
                >
                    {{ pifInfos.radInfos.buttonLabel }}
                </a>
            </div>
        </div>
        <ol class="ob1-timeline pif-infos--collapse" :hidden="!showDetails">
            <li
                v-for="step in pifInfos.deploymentSteps"
                class="ob1-timeline-step"
                :class="(step.current ? 'active progress-66' : '') + (step.complete ? 'complete' : '')"
            >
                <p class="ob1-timeline-title">
                    {{ step.title }}
                </p>
                <p v-if="step.syndicInfos" class="ob1-timeline-description">
                    {{ step.syndicInfos.description }}
                </p>
                <p v-if="step.syndicInfos" class="ob1-timeline-description">
                    <a
                        class="ob1-link-arrow"
                        :href="step.syndicInfos.courrierTypeLink"
                        target="_blank"
                    >
                        {{ step.syndicInfos.courrierTypeLabel }}
                    </a>
                </p>
            </li>
        </ol>
        <ol class="ob1-timeline ob1-timeline--collapsed pif-infos--collapse" :hidden="showDetails">
            <li
                v-for="step in pifInfos.deploymentSteps"
                v-if="step.current || step.complete"
                class="ob1-timeline-step"
                :class="step.current ? 'active' : 'complete'"
            >
                <p class="ob1-timeline-title">
                    {{ step.title }}
                </p>
                <p v-if="step.syndicInfos" class="ob1-timeline-description">
                    {{ step.syndicInfos.description }}
                </p>
                <p v-if="step.syndicInfos" class="ob1-timeline-description">
                    <a
                        class="ob1-link-arrow"
                        :href="step.syndicInfos.courrierTypeLink"
                        target="_blank"
                    >
                        {{ step.syndicInfos.courrierTypeLabel }}
                    </a>
                </p>
            </li>
        </ol>
        <a
            :href="pifInfos.url"
            class="btn btn-secondary my-1 pif-infos--collapse"
            :hidden="!showDetails"
            :data-oevent-category="pifInfos.buttonTms.category"
            :data-oevent-action="pifInfos.buttonTms.action"
            :data-oevent-label="pifInfos.buttonTms.label"
        >
            {{ pifInfos.buttonLabel }}
        </a>
        <button
            id="pif-infos__collapse-button"
            class="ob1-link-arrow pif-infos--collapse"
            aria-expanded="true"
            :hidden="!showDetails"
            @click="toggle"
        >
            {{ pifInfos.seeLessLabel }}
        </button>
        <button
            id="pif-infos__expand-button"
            class="ob1-link-arrow pif-infos--collapse"
            aria-expanded="false"
            :hidden="showDetails"
            @click="toggle"
        >
            {{ pifInfos.seeMoreLabel }}
        </button>
    </section>
</template>

<script>
export default {
    name: "PifInfos",
    props: {
        pifInfos: {
            type: Object, required: true
        }
    },
    data() {
        return {
            showDetails: false
        }
    },
    methods: {
        toggle() {
            this.showDetails = !this.showDetails;
        }
    }
}
</script>

<style scoped>

</style>
